"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeAdjacentUnicodeTextNodes = void 0;
function appendTextContentOnto(appendee, suffix) {
    if (appendee.firstChild instanceof Text &&
        suffix.firstChild instanceof Text &&
        appendee.firstChild.textContent != null &&
        suffix.firstChild.textContent != null) {
        appendee.firstChild.textContent += suffix.firstChild.textContent;
    }
}
// mergeAdjacentUnicodeTextNodes is a workaround for this MathJax bug:
// https://github.com/mathjax/MathJax/issues/3041
function mergeAdjacentUnicodeTextNodes(dom) {
    for (const mtext of dom.querySelectorAll("mjx-mtext")) {
        // `head` is the first element in a sequence of consecutive unicode
        // text elements.
        let head = null;
        // To merge adjacent unicode text nodes, we append
        // each node's text content onto the head and remove the original node.
        const toRemove = [];
        for (const child of mtext.childNodes) {
            if (child instanceof HTMLElement && child.tagName === "MJX-UTEXT") {
                if (head == null) {
                    head = child;
                }
                else {
                    appendTextContentOnto(head, child);
                    toRemove.push(child);
                }
            }
            else {
                head = null;
            }
        }
        for (const child of toRemove) {
            mtext.removeChild(child);
        }
    }
    return dom;
}
exports.mergeAdjacentUnicodeTextNodes = mergeAdjacentUnicodeTextNodes;
